import { Action, createReducer, on } from '@ngrx/store';
import { fetchAgentsRequestsList, fetchAgentsRequestsListSuccess, fetchAgentsRequestsListFailure, fetchAgentRequestDetail, fetchAgentRequestDetailSuccess, fetchAgentRequestDetailFailure } from './agents-requests.action';


export interface AgentsRequestsState {
  list: any[];
  detail:any;
  loading: boolean;
  error: any;
  pageNumber: number;
  pageSize: number;
  totalPages: number;
  totalRecords: number;
}

export const initialState: AgentsRequestsState = {
  list: [],
  detail: null,
  loading: false,
  error: null,
  pageNumber: 1,
  pageSize: 10,
  totalPages: 100,
  totalRecords: 100,
};

export const AgentsRequestsReducer = createReducer(
  initialState,
  on(fetchAgentsRequestsList, (state) => {
    return { ...state, loading: true, error: null };
  }),
  on(fetchAgentsRequestsListSuccess, (state, { response }) => {
    return {
      ...state,
      loading: false,
      list: response.result,
      pageNumber: response.pageNumber,
      pageSize: response.pageSize,
      totalPages: response.totalPages,
      totalRecords: response.totalRecords,
    };
  }),
  on(fetchAgentsRequestsListFailure, (state, { error }) => {
    return { ...state, error, loading: false };
  }),
  on(fetchAgentRequestDetail, (state) => {
    return { ...state, loading: true, error: null };
  }),
  on(fetchAgentRequestDetailSuccess, (state, { response }) => {
    return {
      ...state,
      loading: false,
      detail: response
    };
  }),
  on(fetchAgentRequestDetailFailure, (state, { error }) => {
    return { ...state, error, loading: false };
  })
);

// Selector
export function reducer(state: AgentsRequestsState | undefined, action: Action) {
  return AgentsRequestsReducer(state, action);
}
